import { EventTypeInputGroupItem } from '../types/ViewModel/EventTypeInputGroupItem';
import { EventTypeInputGroupItemBM } from '../types/BusinessModel/EventTypeInputGroupItemBM';

export class EventTypeInputGroupItemFactory {
    constructor() {}

    public newEventTypeInputGroupItem(itemList: EventTypeInputGroupItemBM[]): EventTypeInputGroupItem[] {
        const eventTypeInputGroupItemArray: EventTypeInputGroupItem[] = [];
        if (itemList && itemList.length > 0) {
            itemList.map((item) => {
                eventTypeInputGroupItemArray.push(
                    new EventTypeInputGroupItem(item.eventTypeInputGroupItemId, item.eventTypeInputGroupId, item.eventTypeInputId, item.itemOrder)
                );
            });
        }
        return eventTypeInputGroupItemArray;
    }
}
